export const clientGoalsColorsOptions = [
    { key: 'blue', text: 'Zakazano/Poslato',  value: 'blue', image: '/assets/colorImages/blue.png' },
    { key: 'red', text: 'Prioritetan', value: 'red', image: '/assets/colorImages/red.png' },
    { key: 'orange', text: 'U palnu', value: 'orange', image: '/assets/colorImages/orange.png' },
];